import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _moduleTrainers = [];

let ModuleTrainerStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    getAll: function() {
        return _moduleTrainers;
    },

    getByModule: function(id) {
        return _moduleTrainers.filter(function(e) { return e !== undefined && e.moduleId == id; });
    },

    add: function(trainer) {
        if (trainer !== undefined && trainer.hasOwnProperty('userId') && trainer.hasOwnProperty('moduleId')) {
            trainer.userId = Number(trainer.userId);
            trainer.moduleId = Number(trainer.moduleId);
            let trainerIndex = _moduleTrainers.findIndex((e) => (e !== undefined && e.userId === trainer.userId && e.moduleId === trainer.moduleId) );
            if (0 <= trainerIndex) {
                // use immutable!
                _moduleTrainers[trainerIndex] = trainer;
            } else {
                _moduleTrainers.push(trainer);
            }
        }
    },

    remove: function(data) {
        if (!!data.moduleId && !!data.userId) {
            data.moduleId = Number(data.moduleId);
            data.userId = Number(data.userId);
            let trainerIndex = _moduleTrainers.findIndex((e) => ( e !== undefined && e.userId === data.userId && e.moduleId === data.moduleId ));
            if (0 <= trainerIndex) {
                if (data.success) {
                    delete _moduleTrainers[trainerIndex];
                } else {
                    _moduleTrainers[trainerIndex].loading = false;
                }
            }
        }
    },

    removeByModule: (moduleId) => {
        const mId = Number(moduleId);
        _moduleTrainers = _moduleTrainers.filter((trainer) => (trainer !== undefined && trainer.moduleId !== mId));
    },


});

ModuleTrainerStore.dispatchToken = CentricDispatcher.register(function(action) {
    let data;
    switch(action.type) {
//        case ActionTypes.MODULE_TRAINER_LIST_REQUEST:
//            break;
        case ActionTypes.MODULE_TRAINER_LIST_SUCCESS:
            ModuleTrainerStore.removeByModule(action.payload.moduleId);
            action.data.forEach(ModuleTrainerStore.add);
            ModuleTrainerStore.emitChange();
            break;

        case ActionTypes.MODULE_TRAINER_LIST_FAILURE:
            ModuleTrainerStore.removeByModule(action.payload.moduleId);
            ModuleTrainerStore.emitChange();
            break;

//        case ActionTypes.MODULE_TRAINER_ADD_REQUEST:
//            ModuleTrainerStore.emitChange();
//            break;

        case ActionTypes.MODULE_TRAINER_ADD_SUCCESS:
            ModuleTrainerStore.add(action.data);
            ModuleTrainerStore.emitChange();
            break;

        case ActionTypes.MODULE_TRAINER_ADD_FAILURE:
            ModuleTrainerStore.emitChange();
            break;


//        case ActionTypes.MODULE_TRAINER_DELETE_REQUEST:
//            ModuleTrainerStore.emitChange();
//            break;

        case ActionTypes.MODULE_TRAINER_DELETE_SUCCESS:
        case ActionTypes.MODULE_TRAINER_DELETE_FAILURE:
            data = {
                moduleId:   Number(action.payload.moduleId),
                userId:     Number(action.payload.trainerId),
                success:    action.data
            };

            ModuleTrainerStore.remove(data);
            ModuleTrainerStore.emitChange();
            break;

        default:
            break;
    }

});

export default ModuleTrainerStore;
